module.exports = __webpack_public_path__ + "img/transportation-blue.e384c21d.jpg";